// src/components/BoardPack/components/tables/CfoCommentsSmallTable.jsx
import ErrorState from '@/components/common/ErrorStateComponent';
import LoadingComponent from '@/components/common/LoadingComponent';
import React from 'react';
import AiCfoSection from '../shared/AiCfoSection';

const CfoCommentsSmallTable = ({
  data,
  loading,
  is_cfo,
  error,
  headerTitle = "JEDDAH AIRPORT",
  subHeaderTitle = "Casual Parking Stats",
  month = "",
  prevMonth = "",
  summary,
  isExporting = false,      // ✅ export mode
  cfoComment = "",          // ✅ controlled value from BoardPack
  onCfoCommentChange,       // ✅ setter from BoardPack
}) => {

  if (loading) return <LoadingComponent />;
  if (error) return <ErrorState error={error} />;

  const rows = data?.rows ? Object.keys(data.rows) : [];
  const hasComment = cfoComment.trim() !== "";
  // Add this helper function before the component
const isNegativeValue = (value) => {
  if (!value || value === '-') return false;
  return value.toString().includes('(') && value.toString().includes(')');
};

  return (
    <div className='flex flex-col'>
      <div className="flex justify-center">
        <div className="w-full max-w-4xl !border-2 bg-bg-bw-custom overflow-x-auto">
          <div className="min-w-[574px] lg:min-w-0 lg:w-full">
            <table className="w-full !border-collapse text-[10px] font-medium">
              <thead>
                {/* Row 1 — Main Header */}
                <tr>
                  <th className="text-left px-[8px] py-[6px] !border-r-2 bg-[#001F5F]">
                    <span className='text-white'>{headerTitle}</span>
                  </th>
                  <th colSpan={10} className="text-center px-[6px] py-[6px] bg-[#001F5F]">
                    <span className='text-white'>{subHeaderTitle}</span>
                  </th>
                </tr>

                {/* Empty spacing row */}
                <tr>
                  <td className="py-[8px]"></td>
                  <td colSpan={7} className="py-[8px] !border-l-2"></td>
                  <td colSpan={3} className="py-[8px] !border-l-2"></td>
                </tr>

                {/* Column Headers */}
                <tr>
                  <th className="!border-r-2"></th>
                  <th className="text-center py-[3px] bg-[#001F5F] !border-y-2">
                    <span className='text-white'>{month}<br />Actual</span>
                  </th>
                  <th className="text-center py-[3px] bg-[#001F5F] !border-y-2">
                    <span className='text-white'>{prevMonth}<br />Prior Month</span>
                  </th>
                  <th className="text-center py-[3px] bg-[#001F5F] !border-y-2">
                    <span className='text-white'>Var</span>
                  </th>
                  <th className="text-center py-[3px] !border-r-2 bg-[#001F5F] !border-y-2">
                    <span className='text-white'>Var %</span>
                  </th>
                  <th className="text-center py-[3px] bg-[#001F5F] !border-y-2">
                    <span className='text-white'>{month}<br />Budget</span>
                  </th>
                  <th className="text-center py-[3px] bg-[#001F5F] !border-y-2">
                    <span className='text-white'>Var</span>
                  </th>
                  <th className="text-center py-[3px] !border-r-2 bg-[#001F5F] !border-y-2">
                    <span className='text-white'>Var %</span>
                  </th>
                  <th className="text-center py-[3px] bg-[#001F5F] !border-y-2">
                    <span className='text-white'>{month}<br />Prior Year</span>
                  </th>
                  <th className="text-center py-[3px] bg-[#001F5F] !border-y-2">
                    <span className='text-white'>Var</span>
                  </th>
                  <th className="text-center py-[3px] bg-[#001F5F] !border-y-2">
                    <span className='text-white'>Var %</span>
                  </th>
                </tr>
              </thead>

              <tbody className="bg-bg-bw-custom text-dark-text-custom">
                {rows.map((label, index) => {
                  const rowData = data?.rows?.[label] || {};
                  return (
                    <tr key={index}>
                      <td className="px-[8px] py-[3px] !border-r-2 text-left text-dark-text-custom">{label}</td>
                      <td className={`text-center py-[3px] text-dark-text-custom ${isNegativeValue(rowData.actual) ? 'text-red-600' : ''}`}>{rowData.actual || '-'}</td>
                      <td className={`text-center py-[3px] text-dark-text-custom ${isNegativeValue(rowData.priorMonth) ? 'text-red-600' : ''}`}>{rowData.priorMonth || '-'}</td>
                      <td className={`text-center py-[3px] bg-table-row-column-orange dark:text-black ${isNegativeValue(rowData.varPm) ? 'text-red-600' : ''}`}>{rowData.varPm || '-'}</td>
                      <td className={`text-center py-[3px] !border-r-2 bg-table-row-column-orange dark:text-black ${isNegativeValue(rowData.varPmPct) ? 'text-red-600 !border-black' : ''}`}>{rowData.varPmPct || '-'}</td>
                      <td className={`text-center py-[3px] text-dark-text-custom ${isNegativeValue(rowData.budget) ? 'text-red-600' : ''}`}>{rowData.budget || '-'}</td>
                      <td className={`text-center py-[3px] bg-table-row-column-orange dark:text-black ${isNegativeValue(rowData.varBudget) ? 'text-red-600' : ''}`}>{rowData.varBudget || '-'}</td>
                      <td className={`text-center py-[3px] !border-r-2 bg-table-row-column-orange dark:text-black ${isNegativeValue(rowData.varBudgetPct) ? 'text-red-600 !border-black' : ''}`}>{rowData.varBudgetPct || '-'}</td>
                      <td className={`text-center py-[3px] text-dark-text-custom ${isNegativeValue(rowData.priorYear) ? 'text-red-600' : ''}`}>{rowData.priorYear || '-'}</td>
                      <td className={`text-center py-[3px] bg-table-row-column-orange dark:text-black ${isNegativeValue(rowData.varPy) ? 'text-red-600' : ''}`}>{rowData.varPy || '-'}</td>
                      <td className={`text-center py-[3px] bg-table-row-column-orange dark:text-black ${isNegativeValue(rowData.varPyPct) ? 'text-red-600' : ''}`}>{rowData.varPyPct || '-'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

     <AiCfoSection
  isCfo={is_cfo}
  summary={summary}
  cfoComment={cfoComment}
  onCfoCommentChange={onCfoCommentChange}
  isExporting={isExporting}
/>
      
    </div>
  );
};

export default CfoCommentsSmallTable;